import t9n from "@bimproject/t9n";
import { useTranslation } from "react-i18next";

import ComponentTypeCard from "./ComponentTypeCard";
import { useSuspenseBIMClass } from "../../../../../../clients/taxonomy/useBIMClass";

export default function ComponentTypeCardContainer(props) {
    const { Component = ComponentTypeCard, bimClassID, id, ...restProps } = props;

    const componentType = useComponentType(bimClassID, id);

    const { i18n } = useTranslation();

    if (!componentType) {
        return (<span>-</span>);
    }

    return (
        <Component
            bimClassID={ componentType.bimClass?.id }
            name={ t9n(componentType.name, i18n.language) }
            { ...restProps }
        />
    );
}

function useComponentType(bimClassID: string, componentTypeID: string) {
    return useSuspenseBIMClass(bimClassID).data?.bimClass?.data?.componentTypes?.find?.(
        (componentType) => componentType.id === componentTypeID
    );
}
